import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./login.module.css";
import apiService from "../../../services/api";
import { setupAutoLogout } from "../../../utils/auth";

export default function AdminLogin() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // 이미 로그인된 상태라면 자동 로그아웃 설정
    useEffect(() => {
        // TODO: API 서비스 연동 시 주석 해제
        if (apiService.isAuthenticated()) {
            const cleanup = setupAutoLogout(() => {
                console.log('Login page auto logout triggered');
            });
            apiService.setTokenExpiredCallback(() => {
                console.log('Login page API service token expired callback');
            });
            return cleanup;
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            // TODO: API 서비스 연동 시 주석 해제
            await apiService.login(username, password);
            navigate("/admin/notices");
        } catch (error) {
            setError("로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요.");
            console.error('Login error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={styles.bg}>
            <form className={styles.loginBox} onSubmit={handleSubmit}>
                <h2 className={styles.title}>관리자 로그인</h2>

                {error && <div className={styles.error}>{error}</div>}

                <label className={styles.label}>아이디</label>
                <input
                    type="text"
                    placeholder="아이디 입력"
                    className={styles.input}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    disabled={isLoading}
                />

                <label className={styles.label}>비밀번호</label>
                <input
                    type="password"
                    placeholder="비밀번호 입력"
                    className={styles.input}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={isLoading}
                />

                <button
                    type="submit"
                    className={styles.btn}
                    disabled={isLoading}
                >
                    {isLoading ? "로그인 중..." : "로그인"}
                </button>
            </form>
        </div>
    );
}

